import {ApiClientFactory, ApiClientFactoryInterface} from "./clients";
import {Headers} from "../types";
import {ChatManager} from "../ChatManager";

export class ChatManagerFactory {
  private readonly apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string, headers: Headers) {
    this.apiClientFactory = new ApiClientFactory(
      `${baseUrl}/api/v1/chat`,
      headers
    );
  }

  public createChatManager(token: string): ChatManager {
    return new ChatManager(this.apiClientFactory.createAuthorizedClient(token));
  }
}